import React, { Fragment } from 'react'
import CareersComponent from '../components/careers_v2/careers_component';
import PageHelmet from '../components/common/PageHelmet';

export default function CareersScreen() {
    return (
        <Fragment>
            <PageHelmet 
                title="Careers - Join Rubaai Digital Payment Solutions"
                description="Join Rubaai's dynamic team and help shape the future of digital payments. Explore exciting career opportunities in fintech, technology, and payment solutions."
                keywords="Rubaai careers, job opportunities, fintech jobs, digital payment careers, technology jobs, work at Rubaai, career opportunities"
            />
            <CareersComponent />
        </Fragment>
    );
}
